import React from "react";

const Kotlin_Certificate = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Certificate</h1>
      <p>Content for Kotlin Certificate goes here.</p>
    </div>
  );
};

export default Kotlin_Certificate;
